import { useTranslation } from "react-i18next";
import { CarWashPackage } from "../../types/carWash.types";

interface CarWashCardProps {
  washPkg: CarWashPackage;
  handleClick: (washPkg: CarWashPackage) => void;
}

export const CarWashCard = ({ washPkg, handleClick }: CarWashCardProps) => {
  const { t } = useTranslation();

  return (
    <div
      className="w-72 bg-popupLight dark:bg-popupDark rounded-lg shadow-md hover:shadow-2xl hover:scale-105 transition-transform duration-300 cursor-pointer"
      onClick={() => handleClick(washPkg)}
    >
      <img
        src={washPkg?.imgSrc}
        alt="Product"
        className="w-full h-48 object-cover rounded-t-lg"
      />
      <div className="p-4">
        <h3 className="text-lg font-semibold mb-2 text-primaryText dark:text-primaryTextDark">
          {t(washPkg?.title)}
        </h3>
        <p className="text-primaryText dark:text-primaryTextDark text-sm mb-4">
          {t(washPkg?.description?.[0])}...
        </p>
        <div className="text-base font-bold text-primaryText dark:text-primaryTextDark">
          ₹{t(washPkg?.priceFrom)} - ₹{t(washPkg?.priceTo)}
        </div>
      </div>
    </div>
  );
};
